import React, { useState } from 'react';
import styles from './customDropdown.module.css';

function CustomDropdownFR({ openButtonTitle, content = [], onClick, type }) {
    const [isOpen, setIsOpen] = useState(false);
    console.log(content);

    return (
        <div className={styles.container}>
            <div className={styles.openButtonContainer} onClick={() => { setIsOpen(!isOpen) }}>
                {openButtonTitle}
            </div>
            <div className={`${styles.contentContainer} ${isOpen ? styles.active : ''}`}>
                <div className={styles.list}>
                    {content.length === 0 ? (
                        <div className={styles.noContent}>Ingen forbruksvarer tilgjengelig</div>
                    ) : (
                        type === 'list' ? content.map((item) => (
                            <div key={item.id} className={styles.item}>
                                <span className={styles.span1}>{item.attributes?.name}</span>
                                <span className={styles.span2}>{item.attributes?.price} NOK</span>
                                <button onClick={() => onClick(item)}>Legg til</button>
                            </div>
                        )) : (
                            type === 'custom' && content()
                        )
                    )}
                </div>
            </div>
        </div>
    );
}

export default CustomDropdownFR;